import React from 'react';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { customColors } from '../../utilities';
import moment from 'moment';

export default function DatePickerComponent({
  selected,
  onChange,
  disabled = false,
  editing = false,
  setEditing = () => {},
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        slotProps={{
          textField: {
            sx: {
              '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                borderColor: customColors.SECONDARY_LIGHT,
              },
            },
            error: false,
            InputProps: {
              style: {
                height: '2.5rem',
                backgroundColor: 'white',
                width: '100%',
              },
            },
          },
          actionBar: {
            actions: ['clear'],
          },
        }}
        sx={{ width: '100%' }}
        disabled={disabled}
        value={selected ? moment(parseInt(selected)) : null}
        onChange={(newMoment) => {
          const endOfDay = newMoment?.clone().endOf('day');
          onChange(endOfDay ? String(endOfDay.valueOf()) : null);
        }}
        onAccept={() => setEditing(false)}
      />
    </LocalizationProvider>
  );
}
